import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../../utils/utils';
import { useFormatMessage } from '../../../../../hooks';
import { editOrder } from '../../../../../crud/orders.crud';
import { IEditOrder, IOrderResponse } from '../../../../../interfaces/order';

export const useEditOrder = () => {
  const { enqueueSnackbar } = useSnackbar();
  const fm = useFormatMessage();
  const [loadingEdit, setLoading] = useState(false);
  const [successEdit, setSuccess] = useState(false);
  const [editedOrder, setOrder] = useState<IOrderResponse>();
  const editOrderTaxi = async (id: number, order: IEditOrder) => {
    setLoading(true);
    editOrder(id, order)
      .then(res => {
        setSuccess(true);
        setOrder(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
          setOrder(undefined);
        }, 100);
      });
  };

  return { editOrderTaxi, successEdit, loadingEdit, editedOrder };
};
